<template>

    <div class="order-nav-section">
        <a v-show="step == 1" v-on:click="goHome()" class="order-button orderCancelButton"><i class="ion-android-close"></i></a>
        <a v-show="step > 1" href="#/" class="order-button order-button-left orderSubmitButton" v-on:click="decreseStep();">
            <h5>Wstecz</h5>
        </a>
        <h4 v-show="step < 6">Krok {{step}}/{{stepsCount}}</h4>
        <h4 v-show="step >= 6">&nbsp;</h4>
        <a href="#/" class="order-button order-button-right orderSubmitButton" v-show="step < 5" v-on:click="setStep();">
            <h5>Dalej</h5>
        </a>


        <a href="#/" v-on:click="pay();" v-show="step == 6 && orderType == 'orderToPay'" class="order-button orderSubmitButton"><h5>Zapłać z PayU</h5></a>
        <div style="display: flex; justify-content: center;">
        <a href="#/" v-on:click="makeOrder('orderToPay');" v-show="step == 5" class="order-button orderSubmitButton"><h5>Zamawiam - link do płatności</h5></a>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'orderNavSection',
        props: ["step"],
        data () {
            return {
                stepsCount: 5
            }
        },
        methods: {

            makeOrder: function(orderType) {
                if (orderType === 'doubleOrder') {
                    this.$store.commit('setOrderType', 'doubleOrder')
                } else if (orderType === 'orderToPay') {
                    this.$store.commit('setOrderType', 'orderToPay')
                }
                this.$emit('setOrderStep', this.step + 1);
            },

            goHome: function() {
                // @TODO
                window.location = '/';
            },

            decreseStep: function () {
                if (this.step === 6) {
                    this.$emit('setFinishedOrderPopup', true);
                } else {
                    this.$emit('setOrderStep', this.step - 1);
                }
            },

            pay: function() {
                this.$emit('pay');
            },

            setStep: function () {
                console.log("setStep" + this.step);
                if (this.step === 2 && !this.$store.state.directionServiceResults) {
                    return
                } else {
                    this.$emit('setOrderStep', this.step + 1);
                }

            },

            createOrder: function () {
                console.log('createOrder');
                this.$emit('createOrder');
            }
        },

        computed: {
            orderType: function () {
                return this.$store.state.orderType
            },
            orderCreated: function () {
                return this.$store.state.orderCreated
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// OrdeNavSection.vue?c45858c0